module.exports = __webpack_public_path__ + "img/image2.4740193a.png";